// Smart Living Interiors — official brand mark (processed to transparent PNG)
export function LogoMark({ className = "h-9 w-auto" }) {
  return (
    <img
      src="/logo-mark.png"
      alt="Smart Living Interiors logo"
      className={className}
      draggable="false"
    />
  );
}

// Full lockup: mark + wordmark (+ optional tagline)
export function Logo({ markClass = "h-9 w-auto", textClass = "text-foreground", tagline = true }) {
  return (
    <span className="flex items-center gap-2.5">
      <LogoMark className={markClass} />
      <span className={`leading-none ${textClass}`}>
        <span className="block font-sans font-bold tracking-[0.12em] text-base">SMART LIVING</span>
        {tagline && <span className="block text-[10px] font-sans uppercase tracking-[0.34em] mt-0.5 text-gold">Interiors</span>}
      </span>
    </span>
  );
}
